<template>
  <v-app class="app">
    <WelcomeBackDialog />
    <!-- <CongratulationsDialog /> -->

    <v-main :style="{ backgroundColor: $vuetify.theme.dark ? '#111' : '#EA532E' }">
      <MenuDrawer />

      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>

    <Footer />
    <NavBar @font-size-changed="updateFontSize" />
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import MenuDrawer from "@/components/MenuDrawer.vue";
import WelcomeBackDialog from "@/components/WelcomeBackDialog.vue";
import Footer from "@/components/Footer.vue";
import { SCORM } from "pipwerks-scorm-api-wrapper";
//import CongratulationsDialog from "@/components/CongratulationsDialog.vue";

export default {
  name: "App",

  components: {
    NavBar,
    MenuDrawer,
    WelcomeBackDialog,
    Footer,
  },

  data: () => ({
    isTabClosed: false,
  }),

  methods: {
    updateFontSize(fontSize) {
      document.documentElement.style.fontSize = fontSize + "px";
    },

    handleBeforeUnload(event) {
      // This method will be called when the user leaves the page or closes the tab
      this.isTabClosed = true;

      // Optionally, you can show a confirmation dialog to the user
      event.preventDefault();
      event.returnValue = "";
    },
  },

  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },

  created() {
    const data = JSON.parse(SCORM.get("cmi.suspend_data"));
    if (data) {
      console.log(`created - tem data: ${JSON.stringify(data)}`)
      this.$store.state.progresso_topicos = data;
    } else {
      console.log("NAO TEM DATA")
    }
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  beforeCreate() {
    const lastRouteName = localStorage.getItem("brisanet-modulo-1");
    console.log(lastRouteName);

    if (lastRouteName != "Home") {
      this.$store.commit("TOGGLE_WELCOME_BACK");
    }
  },

  watch: {
    isTabClosed(newValue) {
      if (newValue) {
        console.log("CLOSING...");

        SCORM.set("cmi.score.raw", this.$store.state.progresso_topicos.LMS_Progress);
        SCORM.set("cmi.core.lesson_status", this.$store.state.progresso_topicos.completion_status);
        SCORM.set("cmi.suspend_data", JSON.stringify(this.$store.state.progresso_topicos));

        SCORM.save();
        SCORM.quit();
      }
    },

    '$store.state.progresso_topicos.LMS_Progress'(newValue) {
      if(newValue === 100) {
        console.log("COMPLETOU")
        this.$store.state.showCongratulations = true
        this.$store.state.progresso_topicos.completion_status = "completed";
        SCORM.set("cmi.core.lesson_status", "completed");
        SCORM.save();
      }
    }
  },
};
</script>

<style lang="scss">
body {
  font-size: 18px;
  background-color: #EA532E;
}

.v-application--wrap {
  background: #f2f2f2;
}

#app {
  min-height: 100vh;
  max-width: 100vw;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a:link, a:visited {
  color: #FF5022;
}

p {
  margin: 1.8rem 0 !important;
  line-height: 1.7rem !important;
}

p:first-of-type {
  margin-top: 0 !important;
}

p:last-of-type {
  margin-bottom: 0 !important;
}

.v-card__text {
  font-size: 1.05rem;
  line-height: 1.7rem !important;
}

.label-radio-input {
  border-radius: 4px;
  padding: 8px 10px;
  margin: 3px;
  transition: background 200ms ease;
  cursor: pointer;
}

.label-radio-input:hover {
  background: #eee;
}

input[type="radio"] {
  transform: scale(1.5);
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 10px 28px !important;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 12px !important;
}

/* EXPANSION-PANEL */
.v-expansion-panel--active > .v-expansion-panel-header {
  font-weight: bold;
  color: #ffffff;
  background: #1565ac;
  margin-bottom: 20px;
}

.v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(
    .v-expansion-panel-header__icon--disable-rotate
  )
  .v-icon {
  color: #ffffff !important;
}

.v-application--is-ltr .v-expansion-panel-header {
  font-weight: bold;
  text-transform: uppercase;
}

/* ROUTE TRANSITION */
.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.4s;
}

.fade-enter-active,
.fade-leave-active {
  transition: 400ms ease all;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

small {
  display: block;
  color: #aaa;
  font-weight: 300;
  font-size: 12px;
}

hr {
  background: #ccc;
  height: 1px;
  border: none;
  margin: 30px 0;
}

.cursor-pointer {
  cursor: pointer;
}

.theme--dark .v-btn.v-btn--disabled {
  background-color: #fff !important; /* Cor personalizada para o botão desativado */
  color: #ddd !important; /* Cor do texto */
}

.animated-box {
  animation: shake 1.5s ease-in infinite;
}

@keyframes shake {
  0% {
    transform: translateX(0px);
  }
  15% {
    transform: translateX(3px);
  }
  30% {
    transform: translateX(0px);
  }
  45% {
    transform: translateX(3px);
  }
  60% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(0px);
  }
}

.v-menu__content {
  box-shadow: none !important;
}

.scaleHover:hover {
  transform: scale(1.01) !important;
  transition: scale 0.1s ease-in-out;
}

/* Estilos para celulares */
@media (max-width: 599px) {
  .container {
    max-width: 100% !important;
  }
}

/* Estilos para tablets */
@media (min-width: 600px) and (max-width: 1023px) {
  .container {
    max-width: 75% !important;
  }
}

/* Estilos para notebooks de 10 polegadas */
@media (min-width: 1024px) and (max-width: 1280px) {
  .container {
    max-width: 700px !important;
  }
}

/* Estilos para monitores maiores */
@media (min-width: 1281px) {
  .container {
    max-width: 1200px !important;
  }
}
</style>
